export const COMPLETED_PROJECTS_FEW_HOMES_THRESHOLD = 20; // When we did below x visible on the map, we display more
export const OUTSIDE_MAP_FEATURED_HOMES_COUNT = 10; // How many more should we show?
export const OUTSIDE_MAP_FEATURED_HOMES_COUNT_MOBILE = 30; // How many more should we show?
